export default __webpack_public_path__ + "static/media/bike-parking.83d133f7.svg";